export default __webpack_public_path__ + "static/media/tips.e161eef3.svg";